import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import type { GetSizeAndVariantFromDimensionsFragmentFragment } from '@packages/gql/generated/shopping/graphql';

const GetSizeAndVariantFromDimensionsFragment = graphql(/* GraphQL */ `
  fragment GetSizeAndVariantFromDimensionsFragment on Product {
    dimensions {
      type
      values {
        displayText
        isSelected
        availability {
          state
        }
      }
    }
  }
`);

export type GetSizeAndVariantFromDimensionsProps = FragmentType<
  typeof GetSizeAndVariantFromDimensionsFragment
>;

export const getSizeAndVariantFromDimensions = (data: GetSizeAndVariantFromDimensionsProps) => {
  const { dimensions } = getFragmentData(GetSizeAndVariantFromDimensionsFragment, data);

  const result: {
    size: string;
    variant: string;
  } = {
    size: '',
    variant: '',
  };

  if (dimensions.length) {
    // filter all input dimensions
    const dimensionsWithoutInput = dimensions.filter((dimension) => dimension?.type !== 'INPUT');

    if (dimensionsWithoutInput) {
      // IMPORTANT! This step is multi dimensional
      // get all selected dimensions
      const allSelectedValues: GetSizeAndVariantFromDimensionsFragmentFragment['dimensions'][number]['values'] =
        [];
      dimensionsWithoutInput.forEach(({ values }) => {
        values.forEach((value) => {
          if (value.isSelected) {
            allSelectedValues.push(value);
          }
        });
      });
      // get display text of all selected dimensions and set variant
      // it's valid to have a result of for example '||' if display text is unset
      if (allSelectedValues.length) {
        result.variant = allSelectedValues.map(({ displayText }) => displayText || '').join('|');
      }

      // get last dimension
      const lastDimension = dimensionsWithoutInput.pop();

      if (lastDimension) {
        // get selected values
        const selectedValues = lastDimension.values.filter((value) => value.isSelected === true);

        if (selectedValues.length) {
          // set size
          result.size = selectedValues.map(({ displayText }) => displayText || '').join('');
        }
      }
    }
  }
  return result;
};
